// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.MapToolbar.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * MapToolbar component
 */
import React from 'react';
import { observer } from 'mobx-react';
import connect from 'share/enhancers/Izenda.Connect';
import DropDown from 'share/components/controls/Izenda.DropDown';
import ReportPartToolbar from '../Izenda.ReporPartToolbar';
import ChartMetrics from '../Izenda.ChartMetrics';
import MapDrilldownBreadcrumb from '../../ReportPartType/Izenda.MapDrilldownBreadcrumb';
import { get, omit, getOr } from 'lodash/fp';
import actions from './Izenda.MapToolbarActions';

const PointOptions = connect(actions)(props => {
  const { localization, reportPart } = props;
  const reportPartContent = reportPart.reportPartContent || {};
  const options = reportPartContent.pointOptionsList;

  if (!options.length) {
    return null;
  }

  return (
    <span>
      <span title="Point Options" className="u_paddingRight izenda-PointOptions-text">
        {localization.getText('REPORTDESIGNER_LABEL_POINT_OPTIONS')}
      </span>
      <DropDown
        options={reportPartContent.pointOptionsList}
        onChange={props.onChangePointOption}
        value={reportPartContent.activePointOption.value}
        valueField="value"
        labelField={getLabelField}
        renderInContainer={false}
        maxHeight={120}
      />
    </span>
  );

  function getLabelField(option) {
    const pointTypeName = get('pointTypeName', option);
    return localization.getText(['REPORT_PART_MAP_POINT', pointTypeName].join('_'));
  }
});

const RightSide = connect(actions)(props => {
  const otherProps = omit('className', props);
  const isShowMetric = getOr(true, 'reportPart.reportPartContent.isShowMetric', props);
  if (get('reportPart.reportPartContent.isBeingBuild', props)) {
    return (
      <span className={props.className}>
        {!props.hideGridPopup && (
          <a className="izenda-GridPopupIcon" title={props.localization.getText('GRID_POPUP_TOOLTIP')}>
            <span className="icon-grid" onClick={props.showGridPreviewPopup} />
          </a>
        )}
        <PointOptions {...otherProps} />
        {isShowMetric && <ChartMetrics {...otherProps} />}
      </span>
    );
  }

  return null;
});

export default observer(props => {
  return (
    <ReportPartToolbar className="izenda-ReportPartMap_toolbar u-posRelative">
      {/* breadcrumb - drill information */}
      <MapDrilldownBreadcrumb {...props} className="izenda-ReportPartMapToolbar_leftSide" />

      {/* metric - list of values to show certain series */}
      <RightSide {...props} className="izenda-ReportPartToolbar_rightSide u-posTopRight u-posAbsolute u_textRight" />
    </ReportPartToolbar>
  );
});


// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartMap/Izenda.MapToolbar.js